import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS'
import getData from '../../../functions/getData';
import { FLYER_DATA, PRINT_WEEKS } from '../../../constants/state';
import ChooseFlyer from '../present/ChooseFlyer';
import getCurrentWeek from '../../../functions/getCurrentWeek';

const mapStateToProps = (state) => ({
    flyerData: getData(state, FLYER_DATA),
    weeks: getData(state, PRINT_WEEKS)
})

const ChooseFlyerContainer = ({
    flyerData,
    basicUrl,
    weeks
}) => {
    const currentWeek = getCurrentWeek(weeks)

    return <ChooseFlyer 
        flyerData={flyerData}
        basicUrl={basicUrl}
        week={currentWeek}
    />  
}

export default connect(mapStateToProps, () => ({}))(toJS(ChooseFlyerContainer))